import React, { useEffect, useState } from 'react';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

interface RenderConfirmModalProps {
  onConfirm: () => void;
  onCancel: () => void;
  busy?: boolean;
  title?: string;
  message?: string;
  confirmLabel?: string;
  busyLabel?: string;
  costSuffix?: string;
}

const RenderConfirmModal: React.FC<RenderConfirmModalProps> = ({
  onConfirm, onCancel, busy,
  title = 'You already generated this style',
  message = 'A render with this exact style already exists in your Renders tab. Regenerating will start a new render and use your quota again.',
  confirmLabel = 'Regenerate Anyway',
  busyLabel = 'Regenerating…',
  costSuffix = 'per render',
}) => {
  const [costLabel, setCostLabel] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_BASE}/api/pricing/catalog`, { credentials: 'include' })
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (cancelled || !data) return;
        const entry = (data.payg || []).find((p: any) => p.featureKey === 'kinetic_caption');
        if (entry) setCostLabel(`≈ ${entry.pricePerUnit} credit${entry.pricePerUnit === 1 ? '' : 's'} ${costSuffix}`);
      })
      .catch(() => { /* ignore */ });
    return () => { cancelled = true; };
  }, [costSuffix]);

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-container" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="modal-close" onClick={onCancel}>✕</button>
        </div>
        <div className="modal-field">
          <p>{message}</p>
          {costLabel && (
            <div className="kc-cost-row">
              <span className="fpw-pill fpw-pill-muted">{costLabel}</span>
            </div>
          )}
        </div>
        <div className="kc-cta" style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
          <button className="btn-sm btn-ghost" onClick={onCancel} disabled={busy}>Cancel</button>
          <button className="btn-sm btn-accent" onClick={onConfirm} disabled={busy}>
            {busy ? busyLabel : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RenderConfirmModal;
